import * as tslib_1 from "tslib";
import { QueryList, ElementRef, AfterViewInit, NgZone, OnInit } from '@angular/core';
import { AgmInfoWindow, AgmMarker } from '@agm/core';
import { GoogleService } from '../../google/google.service';
import { Airport } from '../models/airport.model';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { AirportService } from '../airport.service';
import { EditLocalAttractionComponent } from '../edit-local-attraction/edit-local-attraction.component';
import { DeleteLocalAttractionComponent } from '../delete-local-attraction/delete-local-attraction.component';
var LocalAttractionsComponent = /** @class */ (function () {
    function LocalAttractionsComponent(_google, _zone, _toggleService, _snackBar, _editAttractionDialog, _deleteAttractionDialog, _airportService) {
        this._google = _google;
        this._zone = _zone;
        this._toggleService = _toggleService;
        this._snackBar = _snackBar;
        this._editAttractionDialog = _editAttractionDialog;
        this._deleteAttractionDialog = _deleteAttractionDialog;
        this._airportService = _airportService;
    }
    Object.defineProperty(LocalAttractionsComponent.prototype, "attractions", {
        /**
         * Returns a list of local attractions that have location.
         */
        get: function () {
            return this.airport.localAttractions
                .filter(function (attr) { return attr.location && attr.location.lat && attr.location.lon; });
        },
        enumerable: true,
        configurable: true
    });
    LocalAttractionsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.editModeSet = this._toggleService.getState();
        this._toggleService.toggleEmitter.subscribe(function (isOn) {
            _this.editModeSet = isOn;
        });
    };
    LocalAttractionsComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._google.promise];
                    case 1:
                        _a.sent();
                        if (this.attractions.length < 1) {
                            return [2 /*return*/];
                        }
                        this.latLngBounds = new google.maps.LatLngBounds();
                        this.attractions.forEach(function (attraction) {
                            _this.latLngBounds.extend(new google.maps.LatLng(attraction.location.lat, attraction.location.lon));
                        });
                        // @ts-ignore
                        this.$containerEl = $(this.listEl.nativeElement);
                        return [2 /*return*/];
                }
            });
        });
    };
    LocalAttractionsComponent.prototype.getIconType = function (attraction) {
        switch (attraction.travelType) {
            case 'Restaurant Nearby':
            case 'Restaurant On Field':
                return 'restaurant';
            case 'Accommodations':
                return 'lodging';
            case 'Transportation':
                return 'taxi';
            case 'Attractions':
                switch (attraction.travelRef) {
                    case 'Museum':
                        return 'museum';
                    case 'Golf':
                        return 'golf';
                    case 'National Park':
                    case 'State or Local Park':
                        return 'park';
                }
        }
        return 'attraction';
    };
    LocalAttractionsComponent.prototype.getAddress = function (attraction) {
        var displayAddress = '';
        if (attraction.street1) {
            displayAddress = attraction.street1;
        }
        if (attraction.city) {
            displayAddress = displayAddress + ', ' + attraction.city;
        }
        if (attraction.state) {
            displayAddress = displayAddress + ', ' + attraction.state;
        }
        if (attraction.zip) {
            displayAddress = displayAddress + ' ' + attraction.zip;
        }
        /* if (attraction.country) {
          displayAddress = displayAddress + ', ' + attraction.country;
        } */
        return (displayAddress);
    };
    LocalAttractionsComponent.prototype.getWebsite = function (attraction) {
        if (attraction.website.startsWith('http://') || attraction.website.startsWith('https://')) {
            return (attraction.website);
        }
        else {
            return ('http://' + attraction.website);
        }
    };
    /**
     * Returns a jQuery element container for the given attraction.
     */
    LocalAttractionsComponent.prototype.getAttractionEl = function (attraction) {
        var i = this.attractions.indexOf(attraction);
        if (i < 0) {
            return null;
        }
        var el = this.attractionCardEls.toArray()[i];
        // @ts-ignore
        return $(el.nativeElement);
    };
    /**
     * Scrolls the attractions list to the specified attraction, marking it as selected.
     */
    LocalAttractionsComponent.prototype.scrollToAttraction = function (attraction) {
        var $el = this.getAttractionEl(attraction);
        if (!$el) {
            return;
        }
        var position = $el[0].offsetTop;
        this.$containerEl.animate({ scrollTop: position }, 500);
    };
    /**
     * Hover handler for attraction cards in the list
     */
    LocalAttractionsComponent.prototype.onAttractionItemHover = function (attraction, hover) {
        this._closeAllInfoWindows();
        if (hover) {
            this.selectedAttraction = attraction;
            this._toggleAttractionInfoWindow(attraction, hover);
        }
        else {
            this.selectedAttraction = null;
        }
    };
    LocalAttractionsComponent.prototype.onAirportMarkerClick = function () {
        this.infoWindowOpen(this.airportInfoWindow, this.airportMarker);
    };
    LocalAttractionsComponent.prototype.onAirportMarkerHover = function (hover) {
        if (hover) {
            this.infoWindowOpen(this.airportInfoWindow, this.airportMarker);
        }
        else {
            this.infoWindowClose(this.airportInfoWindow);
        }
    };
    LocalAttractionsComponent.prototype.onAttractionMarkerHover = function (attraction, hover) {
        this._toggleAttractionInfoWindow(attraction, hover);
        if (hover) {
            this.selectedAttraction = attraction;
            this.scrollToAttraction(attraction);
        }
        else {
            this.selectedAttraction = null;
        }
    };
    LocalAttractionsComponent.prototype.onAttractionMarkerClick = function (attraction) {
        this._toggleAttractionInfoWindow(attraction, true);
    };
    LocalAttractionsComponent.prototype._closeAllInfoWindows = function () {
        var _this = this;
        this.infoWindowClose(this.airportInfoWindow);
        this.attractions.forEach(function (attr) { return _this._toggleAttractionInfoWindow(attr, false); });
    };
    LocalAttractionsComponent.prototype._toggleAttractionInfoWindow = function (attraction, open) {
        var i = this.attractions.indexOf(attraction);
        if (i < 0) {
            return;
        }
        var marker = this.attractionMarkers.toArray()[i];
        var window = this.attractionInfoWindows.toArray()[i];
        if (open) {
            this.infoWindowOpen(window, marker);
        }
        else {
            this.infoWindowClose(window);
        }
    };
    LocalAttractionsComponent.prototype.infoWindowOpen = function (infoWindow, marker) {
        if (marker === void 0) { marker = null; }
        infoWindow.hostMarker = marker;
        // Run outside angular to avoid triggering an endless cycle of change detection:
        // https://github.com/SebastianM/angular-google-maps/issues/796
        this._zone.runOutsideAngular(function () {
            infoWindow.open();
        });
    };
    LocalAttractionsComponent.prototype.infoWindowClose = function (infoWindow) {
        this._zone.runOutsideAngular(function () {
            infoWindow.close();
        });
    };
    LocalAttractionsComponent.prototype.reloadAirport = function (identifier) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this._airportService.getAirport(identifier, true)];
                    case 1:
                        _a.airport = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LocalAttractionsComponent.prototype.openEditAttractionDialog = function (index) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '60%';
        dialogConfig.data = {
            airID: this.airport.airportId,
            localAttraction: null,
            isNew: false,
            airportLocation: this.airport.location
        };
        index == null ? dialogConfig.data.isNew = true : dialogConfig.data.localAttraction = this.airport.localAttractions[index];
        dialogConfig.data['airID'] = this.airport.airportId;
        dialogConfig.width = '60%';
        var dialogRef = this._editAttractionDialog.open(EditLocalAttractionComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            _this.reloadAirport(_this.airport.identifier);
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            // isUpdated.success will be false if there is an error during any of the api calls.
            if (isUpdated.success) {
                if (isUpdated.isNew) {
                    // this.airport.pilotControlledLighting.push(isUpdated.pcl);
                    // this.reloadAirport(this.airport.identifier);
                    _this._snackBar.open('Local Attraction', 'Added', {
                        duration: 2000
                    });
                }
                else {
                    _this._snackBar.open('Local Attraction', 'Updated', {
                        duration: 2000
                    });
                }
            }
            else {
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    LocalAttractionsComponent.prototype.deleteAttraction = function (index) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            airportId: this.airport.airportId,
            localAttractionId: this.attractions[index].id
        };
        var dialogRef = this._deleteAttractionDialog.open(DeleteLocalAttractionComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            // isUpdated.success will be false if there is an error during any of the api calls.
            if (isUpdated.success) {
                _this._snackBar.open('Local Attraction', 'Deleted', {
                    duration: 2000
                });
                // this.airport.localAttractions.splice(index, 1);
                _this.reloadAirport(_this.airport.identifier);
            }
            else {
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    return LocalAttractionsComponent;
}());
export { LocalAttractionsComponent };
